import util from '@/libs/util';
import router from '@/router';
import {
	getMenuTreemManageEditInit,
	getMenuTreemManageView
} from '@api/systemmanage/MenuTreemManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getMenuTreemManageEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getMenuTreemManageEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getMenuTreemManageView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getMenuTreemManageView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
